import { writable } from "svelte/store";

const modalStore = writable("");

export default modalStore;
